import React from 'react'
import { useTranslation } from 'react-i18next'
import {
  Dimmed,
  StyledButtonCancel,
  StyledButtons,
  StyledModalContainer,
  StyledContent,
  StyledText,
  StyledTitle,
  StyledWrapper,
} from './StyledModal'
import { ModalDataType } from 'core/store/global/types'

export interface ConfirmModalProps extends ModalDataType {}

const ConfirmModal: React.FC<ConfirmModalProps> = (props) => {
  const { t } = useTranslation()
  const {
    title,
    message,
    cancelText = t('cancel'),
    confirmText = t('confirm'),
    onClose,
    onConfirm: _onConfirm,
  } = props
  const onConfirm = () => {
    _onConfirm?.()
    onClose?.()
  }

  return (
    <StyledModalContainer>
      <Dimmed onClick={onClose} />
      <StyledWrapper>
        <StyledContent title={title}>
          {title && <StyledTitle>{title}</StyledTitle>}
          <StyledText title={title}>{message}</StyledText>
        </StyledContent>
        <StyledButtons>
          <StyledButtonCancel onClick={onClose}>{cancelText}</StyledButtonCancel>
          <button onClick={onConfirm}>{confirmText}</button>
        </StyledButtons>
      </StyledWrapper>
    </StyledModalContainer>
  )
}

export default ConfirmModal
